import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivationStart, Router, RouterOutlet } from '@angular/router';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { AlertController, IonRouterOutlet, MenuController, NavController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, firstValueFrom } from 'rxjs';
import { Modulo } from './models/modulo';
import { Utente } from './models/utente';
import { AuthService } from './services/auth-service/auth-service';
import { ConfigService } from './services/config-service/config-service';
import { PlatformName } from './services/env-service/env-platform';
import { EnvService } from './services/env-service/env-service';
import { PushService } from './services/push-service/push-service';
import { UserService } from './services/user-service';
import { UtilityService } from './services/utility.service';
import { compareVersions } from 'compare-versions';
import { EventsService } from './services/eventsService';
import { register } from 'swiper/element/bundle';
import { ChiaveConfig } from './models/configurazioni/ChiaveConfig';

register();

// import { Nav, Platform, MenuController, Events, AlertController, LoadingController } from '@ionic/angular';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  public loginInProgress: boolean;
  private loginOptions: any;
  public userType: String;
  public isAfam: boolean;

  @ViewChild(IonRouterOutlet) outlet: IonRouterOutlet;

  constructor(public platform: Platform
    , public statusBar: StatusBar
    , public splashScreen: SplashScreen
    , public events: EventsService
    , public nav: NavController
    , protected router: Router
    , private translateService: TranslateService
    , private menuCtrl: MenuController
    , private inAppBrowser: InAppBrowser
    , private envService: EnvService
    , private configService: ConfigService
    , public authService: AuthService
    , private pushService: PushService
    , public userService: UserService
    , public appVersion: AppVersion
    , public alertCtrl: AlertController
    , public utilityService: UtilityService
/*    , private alertCtrl: AlertController
    , private readonly loadingCtrl: LoadingController
    , public deploy: Deploy
    , private safariViewController: SafariViewController*/
    ) {
      this.initializeApp();
  }

  pages: Array<Modulo>;
  fromext = false;
  fromieu = false;
  rootPage: any;
  navParam: any;
  ieudest: any;

  ngOnInit() {
    console.log('app component ngOnInit');
    this.router.events.subscribe(e => {
      if (e instanceof ActivationStart && e.snapshot.outlet === "primary")
        this.outlet.deactivate();
    });
  }

  async initializeApp() {

    this.events.logout.subscribe(data => {
      console.log('app.component logout', data);
      if (this.fromext) {
        const backUrl = this.envService.getExtBaseUrl() + this.authService.getE3CallbackUrl();
        window.location.href = backUrl;
      } else {
        // se non vengono passati dati all'evento è la logout standard richiesta esplicitamente dall'utente
        if (!data) {
          this.authService.logout();
        }
        this.impostaAuthPage();
        this.nav.navigateRoot(this.rootPage);
      }
    });

    await this.platform.ready();
    console.log('this.platform.url()-1', this.platform.url());

    await this.envService.ready();

    if (this.platform.url().match('courtesy')) {
      console.log('calling  courtesy page');
      this.nav.navigateRoot('courtesy');
      return;
    }

    if (this.platform.url().match('fromext')) {
      console.log('call from ext: this.platform.url()', this.platform.url());
      this.fromext = true;
    }

    if (this.platform.url().match('fromieu')) {
      console.log('call from ieu: this.platform.url()', this.platform.url());
      this.ieudest = this.platform.getQueryParam('nav');
      console.log('call from ieu: dest', this.ieudest);
      if (!this.ieudest) {
        this.ieudest = this.authService.readFirstDestFromCookie();
        console.log('call from ieu: dest after reading cookie ', this.ieudest);
      }
      this.fromieu = true;
      this.setDestForIEU();
    }

    // prima operazione è il setup dell'environment
    await firstValueFrom(this.envService.caricaConfigurazioni());
    await this.verificaAggiornamenti(); 
    await this.initTranslation();
    this.pushService.init();

    // autenticazione esterna
    if (this.fromext) {
      console.log('calling fromext');
      // let api = '';
      // api = this.envService.API;
      // // this.envService.API = api.replace('v1', 'jwt/v1');
      // this.nav.navigateRoot('fromext');
      // return;
      this.loginByE3Token().then(() => {
          this.checkAuthAndInit();
      }, (error: any) => {
        let errMssage = this.utilityService.extractErrorMsg(error);
        if (!errMssage) {
          errMssage = this.translateService.instant('error.generic.registyintegration');
        }
        this.utilityService.showAlertAndLogout(errMssage, this.translateService.instant('label.dismiss'));
      });
    } else if (this.fromieu) {
      await this.authService.init();
      console.log('calling fromieu');
      if (!this.authService.getAccessToken() || this.authService.isAuthExpired()) {
        this.authService.writeFirstDestCookie(this.ieudest);
        this.login();
      } else {
        this.checkAuthAndInit();
      }
    } else {
      // // init e caricamento prima pagina
      await this.authService.init();
      this.checkAuthAndInit();
    }
  }


  // oauhLogout() {
  //   // per ora sostituisco la stringa authorize con logout
  //   // andrà aggiunta la costante OAUTH_LOGOUT_URL
  //   let logoutUrl = this.envService.OAUTH_AUTHORIZE_URL;
  //   logoutUrl = logoutUrl.replace('authorize', 'endsession');

  //   // // / // questa implementazione genera un  cors
  //   // console.log( 'eseguo la logout richiamando la ' + logoutUrl );
  //   // this.userService.oauthLogout(logoutUrl).subscribe(
  //   //   data => { console.log('data logout ', data); },
  //   //   err => {  console.log( 'err ' , err ); }
  //   // );
  //   // una redirect non dovrebbe dar problemi
  //   // console.log('getTokenId ' + this.authService.getTokenId());

  //   logoutUrl = logoutUrl +
  //         '?post_logout_redirect_uri=' + this.envService.PWA_URL +
  //         '&id_token_hint=' + this.authService.getTokenId();
  //         // + '&state=A';
  //   // console.log( 'eseguo la logout richiamando la ' + logoutUrl );
  //   this.openUrl(logoutUrl, true);
  //   // this.nav.navigateForward(logoutUrl, { queryParams: { rilevazione: rilevazione } } );

  // }


  async loginByE3Token() {
    console.log('loginByE3Token');
    // console.log('document', document);
    // console.log('document.cookie', document.cookie);
    // console.log('location', location);

    const keyValuePairs = document.cookie.split(/; */);
    for (let i = 0; i < keyValuePairs.length; i++) {
        const name = keyValuePairs[i].substring(0, keyValuePairs[i].indexOf('=')).trim();
        const value = keyValuePairs[i].substring(keyValuePairs[i].indexOf('=') + 1).trim();
        // console.log('name', '*' + name + '*');
        // console.log('value', value);
        if (name === 'e3jwt') {
          console.log('creating e3jwt token');
          const token = value.substring(1);
          // console.log('token', token);
          // console.log('token.split0', token.split('.')[0]);
          // console.log('token.split1', token.split('.')[1]);
          // console.log('token.split2', token.split('.')[2]);
          this.authService.setJwtToken(token);
            await this.callFromExt(token);
            if (this.userService.utente) {
              console.log('utente', this.userService.utente);
            }
        }
    }

  }

  callFromExt(token): Promise<Utente> {
    return this.userService.callFromext(token).toPromise();
  }

  impostaAuthPage() {
    this.disabilitaMenu();
    this.rootPage = 'auth';
  }

  async checkAuthAndInit() {
    console.log('checkAuthAndInit start');
    if (this.authService.isAuthorized()) {
      console.log('checkAuthAndInit auth ok');
      // avvio in modalità già autenticata
      this.userService.init().subscribe(
        () => {
        console.log('checkAuthAndInit userService.init ok');
        // da qui in poi userService è inizializzato con le informazioni dell'utente
        this.pushService.tag('username', this.userService.getUtenteCorrente().username);

        this.configService.caricaConfigurazioni().subscribe(() => {
          this.configService.initParams();
          this.pages = this.envService.getModuli();
          console.log(` pages before filtering ${JSON.stringify(this.pages)}`);
          // restrizione dei moduli visibili in base al ruolo
          const ruolo = this.userService.getUtenteCorrente().ruolo;
          this.pages = this.pages.filter(p => !p.ruolo || p.ruolo.indexOf(ruolo) >= 0 );
          console.log(` pages after filtering ${JSON.stringify(this.pages)}`);
          if(this.pages.length === 0 && !this.fromext) {
            const message = this.translateService.instant('error.generic.forbidden');
            this.utilityService.showAlertAndLogout(message);
            return;
          }
          this.impostaHomePage();
          if (this.navParam) {
            this.router.navigate([this.rootPage, this.navParam] );
          } else {
            this.router.navigate([this.rootPage]);
          }
        });
      },
      err => {
        if (this.fromieu) {
          this.router.navigate(['unf-message']);
        } else {
          // per vari motivi potrebbe fallire il recupero dei dati dell'utente ma segnaliamo
          // genericamente il problema con un toast a scomparsa
          console.error('fallito me, problema di connessione con il server', err);
          this.utilityService.presentToast(this.translateService.instant('app.component.error'));
        }

      });
    } else {
      console.log('checkAuthAndInit auth KO');
      // redirect alla pagina di login
      this.impostaAuthPage();

      this.nav.navigateRoot(this.rootPage);
    }
    console.log('checkAuthAndInit ends');
  }


    setDestForIEU () {
      this.navParam = undefined;
      // doc
        // insegnamenti
        // usa-delega
        // storico-rilevazioni
        // idoneita
        // report
        // storico-deleghe
        // crea-delega

      // stud
        // avvio-marcatura
        // storico-marcature
      switch (this.ieudest) {
        case 'crea-delega':
          this.ieudest = 'insegnamenti';
          this.navParam = { delega: 'delega' };
          return;
        case 'storico-deleghe':
          this.ieudest = 'usa-delega';
          this.navParam = { mode: 'storico' };
          return;
        case 'insegnamenti':
          this.ieudest = 'rilevazione-home';
          return;
        case 'avvio-marcatura':
          this.ieudest = 'marcatura-home';
          return;

        }
  }

  public async login() {
    console.log('login');

    this.loginInProgress = true;
    console.log(this.loginOptions);

    try {
      await this.authService.login();
    } catch(error) {
      console.log('LOGERROR' , error);
    }
    this.loginInProgress = false;
  }

  impostaHomePage() {
    if (this.ieudest) {
      this.rootPage = this.ieudest;
    } else {

      this.abilitaMenu();
      // pagina iniziale in base al ruolo dell'utente
      if (this.userService.fromext) {
        this.impostaLingua();
        this.rootPage = 'fromext';
      } else if (this.userService.isDocente()) {
        this.rootPage = 'rilevazione-home'; // 'RilevazioneHomePage';
      } else if (this.userService.isStudente()) {
        this.rootPage = 'marcatura-home';
      } else if (this.userService.isPTA() && this.envService.isPWA()) {
        this.rootPage = 'report';
      } else if (this.userService.isPTA() && this.envService.isAPP()) {
        this.rootPage = 'impersonamento';
      } else {
        // default nel caso in cui lo userService non dovesse riuscire
        // ad individuare la tipologia di utente
        this.rootPage = 'marcatura-home';
      }
    }
    console.log( `rootpage:  ${this.rootPage}`  );
  }

  menuSwipeEnable(enab: boolean) {
    // This solution works, but pay attention if you need to reenable on ngOnDestroy
    // if you use the same method, you must put the code inside a setTimeout,
    // otherwise app will freeze when clicking any link on the menu
    this.menuCtrl.get().then((menu: HTMLIonMenuElement) => {
      if (menu) {
        menu.swipeGesture = enab;
      } else {
        // accade se il menù non è definito
        console.log('menu is undefined');
      }
    });
  }

  impostaLingua() {
    if (this.authService.getLanguage()) {
      this.envService.changeLanguage(this.authService.getLanguage());
    }
  }

  abilitaMenu() {
    this.menuCtrl.enable(true);
    this.userType = this.userService.getUserType();
    if(this.configService.getConfigurazione(ChiaveConfig.E3_BASE_URL) !== 'nil') {
      this.isAfam = true;
    }
    else {
      this.isAfam = false;
    }
    // this.menuCtrl.swipeEnable(true);
    this.menuSwipeEnable(true);
  }

  disabilitaMenu() {
    this.menuCtrl.enable(false);
    // this.menuCtrl.swipeEnable(true);
    this.menuSwipeEnable(false);
  }

  logout() {
    this.configService.cleanup();
    this.userService.cleanup();
    this.events.logout.next();
    this.authService.removeOAuthToken();
  }

  async initTranslation() {
    let userLang: string;
    this.translateService.addLangs(['it', 'en']);
    this.translateService.getBrowserLang() === 'it' ? userLang = 'it' : userLang = 'en';
    // Se il linguaggio è it, teniamo ita, mentre ogni altra lingua sarà sempre en
    await firstValueFrom(this.translateService.use(userLang));
    console.log("La lingua utilizzata è:",userLang);
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translateService.setDefaultLang('en');

  }

   openPage(page) {
    console.log('openpage ' + page);
    if (page.url && page.url.match('^http')) {
      console.log('using  openUrl');
      this.openUrl(page.url);
    } else {
      console.log('using  navigateRoot');
      this.nav.navigateRoot((<string>page.url).toLowerCase());
      this.menuCtrl.close();
    }
  }

  openUrl(url: string, autoclose: boolean = false) {

    if (this.platform.is(PlatformName)) { // nell'App
    console.log('app ');
    if (autoclose) {
      console.log('will close new opened window ');
      const browserRef = this.inAppBrowser.create(url, '_blank', 'location=yes,hidden=yes');
      browserRef.on('loadstop').subscribe(() => browserRef.close()) ;
      browserRef.on('loaderror').subscribe(() => browserRef.close()) ;
      } else {
        console.log('will open new window');
        this.inAppBrowser.create(url, '_self', 'location=yes');
      }

    } else { // nel browser
      if (autoclose) {
       this.inAppBrowser.create(url, '_self', 'location=yes');
      } else {
       this.inAppBrowser.create(url, '_blank', 'location=yes');
      }

    }

  }


   // Apre una pagina usando se possibile SafariViewController o Chrome Tab,
   // come fallback usa InAppBrowser
   // @param url
   // cordovaOpenUrl(url: string) {

    // console.log('TODO: REFACTOR IONIC 4 ');
    // this.browserOpenUrl(url);

    /*
    this.safariViewController.isAvailable()
      .then((available: boolean) => {
        if (available) {

          this.safariViewController.show({
            url: url,
            hidden: false,
            animated: true,
            transition: 'curl',
            // tintColor: "#DC2E28",
            // toolbarColor: '#4BB3BB',
            enterReaderModeIfAvailable: true
          })
            .then((result: any) => {
              if (result.event === 'opened') {
                console.log('Opened');
              } else if (result.event === 'loaded') {
                console.log('Loaded');
              } else if (result.event === 'closed') {
                console.log('Closed'); }
            },
            (error: any) => console.error(error)
            );

        } else {
          this.browserOpenUrl(url);
        }
      }
      );*/
  // }

  private async verificaAggiornamenti(): Promise<void> {

    if (this.envService.isPWA()) {
      console.log('verifica aggiornamenti non disponibile per la PWA');
      return;
    }
    let version: any;
    await this.appVersion.getVersionNumber().then( vers => {
      console.log('vers ' + vers);
      version = vers;
    });

   console.log('current version ' + version.toString());
   console.log('last version ' + this.envService.LAST_VERSION);
   if (compareVersions(version.toString(), this.envService.LAST_VERSION) < 0 ) {
      console.log('devi aggiornare');
      this.alertCtrl.create({
        header: 'Attenzione',
        subHeader: 'È disponibile un aggiornamento, vuoi eseguirlo ora?',
        message: 'Il funzionamento delle versioni precedenti non è garantito',
        buttons: [
          {
            text: 'No',
            role: 'cancel'
          },
          {
            text: 'Sì',
            handler: () => {
              const url = this.envService.STORE_URL;
              console.log('store url ' + url);
              // url = 'https://play.google.com/store/apps/details?id=it.unime.mobile.docenti';
              if (url) {
                this.inAppBrowser.create(url, '_system', 'location=yes');
              }
            }
          }
        ]
      }).then(res => res.present());
    }


   }
}
